import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from '../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { ButtonTypeEnum } from '../../buttons/button/button-type.enum';
import { CloseButtonComponent } from '../../buttons/close-button/close-button.component';
import { ButtonComponent } from '../../buttons/button/button.component';

@Component({
  selector: 'app-base-loading-button-modal',
  templateUrl: './base-loading-button-modal.component.html',
  styleUrls: ['../../../views/shared/modals/base-action-modal/base-action-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, CloseButtonComponent, ButtonComponent]
})
export class BaseLoadingButtonModalComponent extends BaseModalComponent implements OnChanges {
  // Ensure modalTitle is localized before being passed in
  @Input() modalTitle: string = '';
  // Ensure primaryLabel is localized before being passed in
  @Input() primaryLabel: string = '';
  // Ensure secondaryLabel is localized before being passed in
  @Input() secondaryLabel: string = '';

  @Input() isLoading: boolean = false;
  @Input() hidePrimary: boolean = false;
  @Input() hideSecondary: boolean = false;
  @Input() hideClose: boolean = false;
  // Use in conjunction with ignoreEscapeModalOptions to ensure the modal
  // cannot be closed on escape
  @Input() ignoreEscape: boolean = false;

  @Output() closeClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() primaryClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) {
    super(activeModal);
  }

  private _isLoading = new BehaviorSubject(false);
  public isLoading$ = this._isLoading as Observable<boolean>;

  setupBindings(): void {}

  setupViews(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isLoading) {
      this._isLoading.next(this.isLoading);
    }
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
